/* Oferta de cadastro minimizada no canto da tela (substitui o pop-up de tela cheia). */
(function () {
  if (customElements.get('newsletter-teaser')) return;

  var FLAG_SUBMIT = 'nlTeaserSubmitted';
  var FLAG_DONE = 'nlTeaserDone';

  function storageGet(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }
  function storageSet(store, key, value) {
    try { window[store].setItem(key, value); } catch (e) {}
  }
  function storageRemove(store, key) {
    try { window[store].removeItem(key); } catch (e) {}
  }

  class NewsletterTeaser extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.tab = this.querySelector('[data-teaser-toggle]');
      this.panel = this.querySelector('.newsletter-teaser__panel');
      this.closeBtn = this.querySelector('[data-teaser-close]');
      this.form = this.querySelector('form');
      this.fields = this.querySelector('[data-teaser-fields]');
      this.success = this.querySelector('[data-teaser-success]');
      this.error = this.querySelector('[data-teaser-error]');

      var state = this.querySelector('[data-teaser-state]');
      var posted = state && state.dataset.posted === 'true';
      var hasError = state && state.dataset.error === 'true';
      var submittedHere = storageGet('sessionStorage', FLAG_SUBMIT) === '1';
      storageRemove('sessionStorage', FLAG_SUBMIT);

      /* Outros formularios de cadastro da pagina (ex.: rodape) nao devem reagir a este envio. */
      window.newsletterTeaserPosted = submittedHere && (posted || hasError);

      if (submittedHere && posted) {
        storageSet('localStorage', FLAG_DONE, '1');
      }
      if (storageGet('localStorage', FLAG_DONE) === '1') {
        this.showSuccess();
      }

      this.tab.addEventListener('click', this.toggle.bind(this));
      this.closeBtn.addEventListener('click', this.close.bind(this));
      this.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') this.close();
      }.bind(this));
      if (this.form) {
        this.form.addEventListener('submit', function () {
          storageSet('sessionStorage', FLAG_SUBMIT, '1');
        });
      }

      if (submittedHere && posted) {
        this.open();
      } else if (submittedHere && hasError) {
        if (this.error && this.error.textContent.trim() !== '') this.error.hidden = false;
        this.open();
      }
    }

    showSuccess() {
      if (this.fields) this.fields.hidden = true;
      if (this.success) this.success.hidden = false;
    }

    open() {
      this.panel.hidden = false;
      this.classList.add('is-open');
      this.tab.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.panel.hidden = true;
      this.classList.remove('is-open');
      this.tab.setAttribute('aria-expanded', 'false');
      this.tab.focus();
    }

    toggle() {
      if (this.panel.hidden) {
        this.open();
        var first = this.panel.querySelector('input:not([type="hidden"]), copy-coupon');
        if (first && first.focus) first.focus();
      } else {
        this.close();
      }
    }
  }

  customElements.define('newsletter-teaser', NewsletterTeaser);
})();
